// extracted by mini-css-extract-plugin
module.exports = {"cycle":"DaysLeft_cycle__1u8Ye"};